<div class="content-area">
  <h2>Propsaver - {{this.customerInfo?.customerName}}</h2>
  <h4>Ställ in måltemperaturer för respektive värmesystem.</h4>
  <div class="customer-settings">
    <bms-customer-settings [customerId]="data.customerId" [admin]="false" [key]="'setpoint'"></bms-customer-settings>
  </div>
</div>

